module.exports = __webpack_public_path__ + "img/insta_logo.30fa0886.png";